import { render, staticRenderFns } from "./MesInfoBasicForm.vue?vue&type=template&id=fa53a778&"
import script from "./MesInfoBasicForm.vue?vue&type=script&lang=js&"
export * from "./MesInfoBasicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports